const storesLink = 'https://investengine.onelink.me/LSNd/l4pxsd9h'

export default storesLink
